function ComparisonWithOtherAsset({ type }) {
  if (type === "tick")
    return (
      <img
        src="assets/images/icons/tick-25_X_25.png?width=21&amp;height=21&amp;name=tick-25_X_25.png"
        class="me-1"
        height="21"
        width="21"
        loading="lazy"
        alt="✅"
        srcset="
                    assets/images/icons/tick-25_X_25.png?width=11&amp;height=11&amp;name=tick-25_X_25.png 11w,
                    assets/images/icons/tick-25_X_25.png?width=21&amp;height=21&amp;name=tick-25_X_25.png 21w,
                    assets/images/icons/tick-25_X_25.png?width=32&amp;height=32&amp;name=tick-25_X_25.png 32w,
                    assets/images/icons/tick-25_X_25.png?width=42&amp;height=42&amp;name=tick-25_X_25.png 42w,
                    assets/images/icons/tick-25_X_25.png?width=53&amp;height=53&amp;name=tick-25_X_25.png 53w,
                    assets/images/icons/tick-25_X_25.png?width=63&amp;height=63&amp;name=tick-25_X_25.png 63w
                "
        sizes="(max-width: 21px) 100vw, 21px"
      />
    );
  else
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 20 20"
        fill="none"
      >
        <circle cx="10.5" cy="10.5" r="7.5" fill="#DC2626"></circle>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 0C15.523 0 20 4.47701 20 10C20 15.523 15.523 20 10 20C4.47701 20 0 15.523 0 10C0 4.47701 4.47701 0 10 0ZM11.4142 10L14.2426 7.17157C14.6332 6.78105 14.6332 6.14788 14.2426 5.75736C13.8521 5.36684 13.219 5.36684 12.8284 5.75736L10 8.58579L7.17157 5.75736C6.78105 5.36684 6.14788 5.36684 5.75736 5.75736C5.36684 6.14788 5.36684 6.78105 5.75736 7.17157L8.58579 10L5.75736 12.8284C5.36684 13.219 5.36684 13.8521 5.75736 14.2426C6.14788 14.6332 6.78105 14.6332 7.17157 14.2426L10 11.4142L12.8284 14.2426C13.219 14.6332 13.8521 14.6332 14.2426 14.2426C14.6332 13.8521 14.6332 13.219 14.2426 12.8284L11.4142 10Z"
          fill="#E3BFBF"
        ></path>
      </svg>
    );
}
export default ComparisonWithOtherAsset;
